import {AfterViewInit, Component, Inject, OnInit} from '@angular/core';
import {StickyCloseDialogComponent} from '../sticky-close-dialog/sticky-close-dialog.component';
import {MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef} from '@angular/material';
import {DeviceService} from '../../../services/device.service';
import {AssetsService} from '../../../services/assets.service';
import {DialogConfigInterface} from '../dialog-config.interface';
import {DialogConfigBase} from '../dialog-config-base';
import {Offer} from '../../../../core/models/offer/offer.model';
import {
  OffersPresentationData, OffersPresentationMode,
  OffersPresentationService
} from '../../../../core/services/impl/offers-presentation.service';
import {OfferResourceService} from '../../../../core/services/impl/offer-resource.service';
import {
  InsuranceDataSummaryContext
} from '../../../sections/web/next-offers-section/insurance-data-summary/insurance-data-summary.component';
import {isCarOne, isEmbeddedInIframe} from '../../../../core/utils/utils';

@Component({
  selector: 'app-offers-comparison-dialog',
  templateUrl: './offers-comparison-dialog.component.html'
})
export class OffersComparisonDialogComponent extends StickyCloseDialogComponent implements OnInit, AfterViewInit {

  contentScrolled: boolean = false;
  scrollSelector = '.app-offers-dialog';
  removeIcon: string;
  comparisonMode: boolean;
  singleOfferMode: boolean;
  offers: Offer[];
  owuDownloadIcon: string;
  coveragesComparisonData: OfferCoveragesGroupComparisonData[];

  DataSummaryContext = InsuranceDataSummaryContext;
  isCarOne: boolean = isCarOne();

  static getConfigBuilder(): OffersComparisonDialogConfig {
    return new OffersComparisonDialogConfig();
  }

  get downloadOWUButtonLabel(): string {
    return this.offersPresentationService.isNext ? 'OFFER_SECTION.COMPARE.downloadOWU' : 'OFFER_SECTION.COMPARE.download';
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: OffersPresentationData,
              public dialog: MatDialogRef<any>,
              public deviceService: DeviceService,
              public assetsService: AssetsService,
              public offerResourceService: OfferResourceService,
              public offersPresentationService: OffersPresentationService) {
    super(deviceService);
    this.comparisonMode = this.data.mode === OffersPresentationMode.OFFERS_COMPARISON;
    this.singleOfferMode = this.data.mode === OffersPresentationMode.OFFER_DETAILS;
    this.offers = this.data.offers;
    this.offersPresentationService.init(data);
    this.createCoveragesComparisonData();
    this.initOwuDownloadIcon();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.initRemoveIcon();
    this.updateContentScrolled = this.updateContentScrolled.bind(this);
    this.handleScroll();
  }

  ngAfterViewInit(): void {
    this.offerResourceService.updatePdfLinks();
  }

  close() {
    this.dialog.close();
  }

  selectOffer(offer: Offer): void {
    this.dialog.close(offer);
  }

  private initOwuDownloadIcon(): void {
    this.owuDownloadIcon =  `${this.assetsService.getIconsDirectoryPath()}/download-pdf.svg`;
  }

  private createCoveragesComparisonData(): void {
    this.coveragesComparisonData = this.offersPresentationService.getCoveragesComparisonData();
  }

  private updateContentScrolled(): void {
    this.contentScrolled = document.querySelector(this.scrollSelector).scrollTop > 0;
  }

  private handleScroll(): void {
    const panel = document.querySelector(this.scrollSelector);
    panel.addEventListener('scroll', this.updateContentScrolled);
  }

  private initRemoveIcon(): void {
    this.removeIcon = this.offersPresentationService.isNext ? 'highlight_off' : 'close';
  }
}

export class OffersComparisonDialogConfig extends DialogConfigBase implements DialogConfigInterface {
  private config: MatDialogConfig = {
    disableClose: true,
    panelClass: ['app-offers-dialog', 'app-offers-dialog--next', 'offers-comparison-dialog-panel']
  };

  constructor() {
    super();
  }

  buildConfiguration(data: any): MatDialogConfig {
    if (isEmbeddedInIframe()) {
      (this.config.panelClass as string[]).push('offers-comparison-dialog-panel--embedded-in-iframe');
    }
    return this.buildConfig(data, this.config);
  }
}

export interface OfferCoveragesGroupComparisonData {
  label: string;
  coverages: OfferCoveragesComparisonData[];
}

export interface OfferCoveragesComparisonData {
  code: string;
  label: string;
  tooltip?: string;
}

